export default __webpack_public_path__ + "4a4f056.png";